import { T as TextField, d as defineCustomElement$1 } from './text-field.js';

const TtTextField = TextField;
const defineCustomElement = defineCustomElement$1;

export { TtTextField, defineCustomElement };
